import { render, staticRenderFns } from "./tab-plugins.vue?vue&type=template&id=f0d44226&scoped=true"
import script from "./tab-plugins.vue?vue&type=script&lang=js"
export * from "./tab-plugins.vue?vue&type=script&lang=js"
import style0 from "./tab-plugins.vue?vue&type=style&index=0&id=f0d44226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d44226",
  null
  
)

export default component.exports